module.exports = __webpack_public_path__ + "assets/7cfbd9f85d97fd6451884de74e4d9b2b.json";